import CartItemDto from "./CartItem.dto";
import CartStateDto from "./CartState.dto";

export enum CartStatus {
    OK = 'ok',
    ERROR = 'error'
};

export enum DevicePlatform {
    WEB = 'web',
    ANDROID = 'android',
    IOS = 'ios',
    CMS = 'cms',
    B2B = 'b2b',
}

export interface CartDto {
    status: CartStatus;
    state: CartStateDto;
    items: CartItemDto[];
    campaigns?: CartItemDto[];
    notices?: string[];
    total_items_price: number;
    final_price: number;
    device_token: string;
    device_platform: DevicePlatform;
    identity_token?: string;
    items_count?: number;
}

export default CartDto;